__turbopack_context__.v({
  "ImageLightBox": "g799sG_ImageLightBox",
  "ImageLightBox--PositionRelative": "g799sG_ImageLightBox--PositionRelative",
  "ImageLightBox__IconContainer": "g799sG_ImageLightBox__IconContainer",
  "ImageLightBox__LightBox": "g799sG_ImageLightBox__LightBox",
});
